module.exports = __webpack_public_path__ + "static/media/taiwan-mall-interior.bd0d5a92.jpg";